import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";
import { DICTS } from "@/lib/i18n";

export const Route = createFileRoute("/account/analytics/select-property")({
  component: lazyRouteComponent(() => import("./-pages/account.analytics.select-property")),
  head: () => ({
    meta: [
      { title: DICTS.en["account.analytics.select.meta_title"] ?? "Select property — Lecmo" },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
});
